import { gql } from '@apollo/client';

export const FETCH_REPORT_SCHEDULE = gql`
    query fetchReportSchedule($reportDefinitionId: Guid!, $reportScheduleFilter: ReportDefinitionScheduleFilter!) {
        facility {
            id
            reportDefinition(id: $reportDefinitionId) {
                schedules(filter: $reportScheduleFilter) {
                    id
                    alias
                    cron {
                        expression
                        description
                    }
                    contacts {
                        id
                    }
                    emailSubject
                    emailContent
                    activeFromTime
                    activeToTime
                    useFacilityTime
                    reportDefinitionId
                }
            }
        }
    }
`;
